<template>
  <div class='indexpage'>
                 <div class='inform ' v-show='informShow'>
                      <!-- <div class='informBox'> -->
                        <div class='container-fluid' >
                        <div class='row'>
                            <div class='col-xs-1 col-sm-1 col-md-2 col-lg-2'></div>
                            <div class='col-xs-10 col-sm-10 col-md-8 col-lg-8 informBox' style='max-height:80vh;overflow-y:scroll;'>
                                  <div class='informTitle h2'>消费者告知书</div>
                                  <div class='informTxt h4' style='text-indent:0;'>尊敬的客户：</div>
                                  <div class='informTxt h4'>您好！为帮助您更好地选购跨境商品，请您在购买前务必认真、详细阅读并完全理解本告知书的全部内容，并对自身风险承担做出客观判断。同意本告知书内容后再下单购买：</div>
                                  <div class='informTxt h4'>1.您在本平台购买的跨境商品等同于直接境外购买，商品本身可能无中文标签，如有需要，您可以通过产品详情页查看相关商品标签中文翻译或联系客服。</div>
                                  <div class='informTxt h4'>2.根据相关法律政策，您选购的跨境商品仅限个人自用，不得进行再次销售。</div>
                                  <div class='informTxt h4' style='margin-bottom: 100px;'>3.您购买的跨境商品符合原产地有关质量、安全、卫生、环保、标识等标准或技术规范要求，可能与我国标准有所不同，由此可能产生的危害、损失或者其他风险，将由您自行承担。</div>
                                  

                                  <div class='informBtnBox' >
                                        <div class='informBtn'  @click='closeInform'>同意并继续</div>
                                  </div>


                            </div>



                          </div>
                        </div>
                            
                      </div>                 
                <!-- </div> -->
                



                <div class='topindex' :style="{backgroundImage:'url('+require('@/assets/index/indextop.png')+')'}">
                  <div  class='topindexBox'>
                      <div class='topindexTitle'><span>按月</span>定制<br/>你的营养补剂</div>
                      <div class='topindexDescription'>从原料到成品131项指标严苛把控 <br/>源自美国 跨境包邮 卓越品质</div>
                      <div class='topindexBtn' >
                         <router-link to="/Product" class='redBtn' style='width: 12vw;min-width: 160px;'>查看产品</router-link>
                         <!-- <router-link to=""  class='whiteBtn' style='width: 180px;'>送给Ta</router-link> -->
                      </div>
                  </div>
              </div>
             
              <div class='step'>
                  <div class='stepBox'>
                      <div class='partTitle'>简单<span >三步</span>，科学定制</div>
                      <div class='stepPart container-fluid'>
                          <div class='row'>
                               <div class='col-xs-12 col-sm-6 col-md-4 col-lg-4' v-for='item in stepTxt' style='margin-bottom: 20px;'>
                                    <div class='stepPartTitle'>{{item.title}}</div>
                                    <div class='stepPartName'>{{item.name}}</div>
                                    <div class='stepPartDescription'>{{item.description}}</div>
                                </div>
                          </div>
                         
                      </div>
                  </div>
                  <img src="../assets/index/grape@2x.png" class='grapeImg '>
                  <img src="../assets/index/ginger@2x.png" class='gingerImg'>
                  <img src="../assets/index/I58A5040@2x.png" class='handleImg'>
              </div>

              <div class='dr'>
                <div class='partTitle'><span >NUTRIPACKS</span><br/>营养研究中心</div>
                <div class='drDescription box-sizing'>位于NUTRIPACKS纽约总部，由美国权威营养学家构成、食品安全学家构成，15年以上营养研发智慧专为你的健康服务。</div>
                <div class='drBox'>
                      <div v-for='team in indexInfo.team_img' class='drTeam'>
                        <img :src="team.formal_url">
                        <div class='drCntont'  @click='toDoctor' :data-id='team.id' style='cursor:pointer;'>
                            <div class='drName' data-team='wo好'  @click='toDoctor' :data-id='team.id'>{{team.member_name}}</div>
                            <div class='drWork'  @click='toDoctor' :data-id='team.id'>{{team.member_title}}</div>
                            <div class='drYear'  @click='toDoctor' :data-id='team.id'>{{team.member_exp}}</div>
                            <div class='drTitle'  @click='toDoctor' :data-id='team.id'>{{team.member_brief}}</div>
                            <div class='drMore' @click='toDoctor' :data-id='team.id' style='cursor:pointer;'>了解更多</div>
        
                        </div>
                      </div>

                </div>

              </div>
              

              <div class='major' :style="{backgroundImage:'url('+require('@/assets/index/Rectangle@2x.png')+')'}" >
                     <div class='partTitle' style='padding-top:68px;'>「卓越Elite」<br/>国际营养师交流计划</div>
                     <div class='majorBtn' style='cursor:pointer;' @click='toCommunication'>专业人士入口</div>
              </div>


              <div class='authentication'>
                  <div class='partTitle' style='padding-top:68px;'>安全承诺 <span>权威认证</span></div>
                  <div class='authenticationBox'>
                        <img src="..//assets/index/authentication.jpg" >
                        <ul>
                          <li>产品通过NSF、NPA&UL权威认证</li>
                          <li>制造环境经FDA注册及GMP、UL认证</li>
                          <li>承诺安全生态、非转基因原材料</li>
                          <li>使用Nu Flow等有机天然辅料</li>
                        </ul>
                  </div>

              </div>

              <div class='product'>
                  
                      <div class='partTitle' style="text-align: center;">最受<span>欢迎</span>单品</div>
                      <div class='indexproductBox'>
                                        <div class='indexgoodsBox' v-for='goods in indexInfo.re_goods'>
                                          <img :src="goods.index_img" class='goodsImg' :data-id='goods.id'  @click='goDetail'>
                                              <div class='indexgoodsName'>{{goods.goods_name}}</div>
                                              <div class='indexgoodsTitle'>{{goods.index_desc}}</div>
                                              <div class='indexgoodsBody'>
                                                <div>
                                                    <img src="../assets/icon-dengpao.png" alt="">
                                                </div>
                                                <div>{{goods.eng_desc}}</div>
                                              </div>
                                              <div class='productMore' :data-id='goods.id'  @click='goDetail' style='cursor:pointer;'>了解更多</div>
                                        </div> 



                    </div>
                  
              </div>

              <div class='bottomBanner' :style="{backgroundImage:'url('+require('@/assets/index/I58A5028@2x.png')+')'}"></div>

              <div class='bottomBtnBox'>
                <div class='bottomBtnName'>自然至上<span>定制健康</span></div>
                <div class='bottomBtnTitle'>如同生活一般，健康需要不断改善</div>
                <div class='bottomBtnTitle'>我们愿与自然、健康、活力一道陪伴在你身边</div>
                <div class='bottomBtnTitle'>开启专属你的每日定制营养体验吧</div>
                <router-link to="/product" class='whiteBtn' >查看产品</router-link>
              </div>
             
              <DrTeam :Dr="activeDr" :fn='closeTeam' v-if='DrShow'/>
</div>
</template>

<script>
import DrTeam from '@/components/DrTeam.vue'
export default {
  name: 'indexPage',
   components: {
    DrTeam
  },
 
  data:function () {
    return{
      logourl:require("@/assets/logo.png"),
      backgroundUrl:"",
      bannerUrl1:"",
      bannerUrl2:"",
      bannerUrl3:"",
      indexInfo:{},
      height:0,
      informShow:true,
      boxShow:true,
      DrShow:false,
      stepTxt:[{title:1,name:"快速问卷",description:"仅需5分钟填写问卷，AI智能系统为你精准配型"},
              {title:2,name:"定制专属健康方案",description:"5大类23款营养补剂，面向14项健康目标科学配置"},
              {title:3,name:"一日一袋",description:"日携袋设计，30袋/盒。美国制造 保税区直邮到家"}
      ]
    }
  },
  beforeCreate:function(argument) {
    let that = this
	console.log()
	// window.location.href = "https://www.nutri-packs.cn/"
	// window.open("https://www.nutri-packs.cn/");

    console.log("请求2")
    this.axios({
            // authority:"https://admin.xiaojudai.cn/index",
            method: 'post',
            url:"/index/getIndex",
            data: {
              member_id:51
            }
          }).then(res=>{
            console.log(res.data)
            that.indexInfo = res.data
            that.backgroundUrl ="background-image:url("+ res.data.home_img[0].url +")"
            that.bannerUrl1=res.data.home_img[1].url
            that.bannerUrl2=res.data.home_img[2].url
            that.bannerUrl3=res.data.home_img[3].url
            console.log(res.data.home_img[0].url)
          })
    

      
 
  },
  mounted(){
    if(!this.$store.state.informShow){
         this.informShow = false
    
    }
    if (window.history && window.history.pushState) {
      // 按需使用：A→B→C就需要页面一进来的时候，就添加一个历史记录
      window.history.pushState(null, null, document.URL);
      // 给window添加一个popstate事件，拦截返回键，执行this.onBrowserBack事件，addEventListener需要指向一个方法
      window.addEventListener("popstate", this.onBrowserBack, false); //添加历史记录
     
    }

    window.addEventListener('scroll', this.handleScroll) //添加监听浏览器滚动
   
    // let _height = $(".btnBox").offset().top + parseInt($(".btnBox").css("height"))
    // console.log(_height)
    // this.height =_height

},
destroyed() {
  // 当页面销毁必须要移除这个事件，vue不刷新页面，不移除会重复执行这个事件
  window.removeEventListener("popstate", this.onBrowserBack, false);
},
watch: {
  // 弹框监听，当弹框显示的时候，pushState添加一个历史，供返回键使用
  PopupShow: {
    handler(newVal, oldVal) {
      if (newVal.Terms === true) {
        window.history.pushState(null, null, document.URL);
      }
    },
    deep: true
  }
},

  methods: {

    // 点击返回键事件
    onBrowserBack() {
    // 这里写点击返回键时候的事件
    // 比如判断需求执行back()或者go(-2)或者PopupShow=false隐藏弹框
    },

   // 屏幕滚动事件
    handleScroll(e){
        
        // let top = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
        //  if(top>this.height){
        //   this.boxShow = false
        //  }else{
        //   this.boxShow = true
        //  }
     
    },
    // 查看营养师详情
    handleTeam(e){
      // console.log($(e.currentTarget)[0].dataset.team)
  
      let _Drteam = this.indexInfo.team_img
      _Drteam.forEach((item)=>{
        if($(e.currentTarget)[0].dataset.team==item.id){
          this.activeDr = item
          console.log(item)
          this.DrShow = true
        }
      }) 
      // let _Drteam = this.data.indexInfo
      // console.log(_Drteam)
      // console.log(e.parent())
     
      
    },
    // 关闭营养师详情
    closeTeam() {
     this.activeDr = {}
     this.DrShow = false
   },
   // 同意告知书
   closeInform(){
       
       this.$store.commit("saveInform",0)
       this.informShow = false
       // console.log(this.$store.state.informShow)
   },
   goDetail(e){
      console.log("跳路由")
      this.$router.push({path:"goods",query:{id:e.target.dataset.id}})
    },
    toDoctor(e){
      let doctorList = this.indexInfo.team_img
      let _params ={}
      doctorList.forEach((item)=>{
        if(item.id==e.target.dataset.id){
          _params =item
        }
      })
      console.log(_params)
      this.$router.push({name:"Doctor", params:{_params}})
    },
    toCommunication(){
      this.$router.push({path:"communication"})
    },


  }
}
</script>

<style scoped lang="scss">









.indexpage{
width: 100%;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.topindex{
  height: 62vw;
  max-height: 100vh;
  width: 100%;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position:bottom;
  -moz-background-size: 100% 100%;
  overflow:hidden;
  position: relative;
  padding-top: 10vw;
  .logo{
    width: 46.5vw;
    margin-top: 14.5vw;
  }
  .topindex::-webkit-scrollbar {
        display: none;
    }
  .bottomImg{
  position: absolute;
  left: 50%;
  margin-left: -25px;
  bottom:0;
  width:50px;
  height:50px;
  }
}
.topindexBox{
/*  width: 290px;*/
  text-align:left;
  position: absolute;
  left: 50%;
  margin-left: 11vw;
  margin-top: -11vw;
  top:50%;
}
.topindexTitle{
  /*width:290px;*/
  font-size:40px;
  font-family:PingFangSC-Medium;
  font-weight:500;
  color:#141414;
  line-height:60px;
  letter-spacing:2px;
  margin-bottom: 1.3vw;
 }

 .topindexTitle span{
    color:#B78975 !important;
    /*border-bottom: 7px solid #F2EEEB;*/
    position: relative;
    z-index: 2;
  }
   .topindexTitle span:after{
    width: 100%;
    height:7px;
    background-color: #F2EEEB;
    content: " ";
    position: absolute;
    border-radius: 2px;
    bottom: -3px;
    left: 0;
    z-index: 1;
   }
.topindexDescription{
  font-size:19px;
  font-family:PingFangSC-Light;
  font-weight:300;
  color:rgba(54,54,54,1);
  line-height:26px;
  margin-bottom: 2vw;
}
.topindexBtn{
display:flex;
justify-content: space-between;
}


.partTitle{
  font-size:30px;
  font-family:PingFangSC-Medium;
  font-weight:500;
  color:rgba(20,20,20,1);
  line-height:45px;
  letter-spacing:2px;
  z-index: 9;
  span{
    color:#B78975 !important;
    position: relative;
    /*border-bottom: 7px solid #F2EEEB;*/
    letter-spacing:0;
    z-index: 2;
  }
}
.partTitle span:after{
    width: 100%;
    height:7px;
    background-color: #F2EEEB;
    content: " ";
    position: absolute;
    border-radius: 2px;
    bottom: -2px;
    left: 0;
    z-index: 1;
}
.stepPartBox{
 width: 220px;
 /*margin:0 auto;*/
 margin:0 3vw;
}
.stepPart{
  display: flex;
  justify-content: center;
  z-index: 9;
  position: relative;
  padding: 107px 0 0;
  margin:0 auto;

  /*max-width:1044px;*/
}
.stepPartTitle{
  margin:0 auto;
   width:83px;
  height:83px;
  border:3px solid rgba(194,94,77,1);
  box-sizing: border-box;
  border-radius: 83px;
  line-height: 83px;
  font-size:40px;
  line-height: 83px;
  font-weight:600;
  color: rgba(194,94,77,1);
  margin-bottom: 17px;
}
.stepPartName{
  height:27px;
  font-size:18px;
  font-family:PingFangSC-Semibold;
  font-weight:600;
  color:#141414;
  line-height:25px;
  margin-bottom: 4px;
}
.stepPartDescription{
   font-size:16px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(20,20,20,1);
  line-height:22px;
  padding: 0 20px;
}

.step{
  padding: 113px 0;
  position: relative;
}


.grapeImg{
  display: block;
  position: absolute;
  width: 132px;
  height:210px;
  left: 0;
  top:191px;
  z-index: 1;
}
.gingerImg{
 display: block;
 position: absolute;
 width: 119px;
 height:57px;
 left: 33px;
 top:440px;
 z-index: 1;
}
.handleImg{
 display: block;
 position: absolute;
 width: 281px;
 height:281px;
 right: 0;
 top:109px;
 z-index: 1;
}

.stepBox{
  max-width: 960px;
  margin:0 auto;
  position: relative;
  z-index: 9;
}
.dr{
  margin-bottom: 90px;
}

.drDescription{

font-size:16px;
font-family:PingFangSC-Regular;
font-weight:400;
color:rgba(20,20,20,1);
line-height:28px;
letter-spacing:1px;
margin:45px auto;
}
.drBox{
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 1210px;
  width: 84vw;
  margin:0 auto;
}
.drTeam{
  margin: 3px;
  width: 295px;
  height:295px;
  position: relative;
  overflow: hidden;
  .drName{
    height:30px;
    font-size:26px;
    font-family:OpenSans-Semibold;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:30px;
    margin-bottom: 5px;
  }
  .drWork{
    font-size:16px;
    font-family:PingFangSC-Medium;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:20px;

  }
  .drYear{
  font-size:14px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(255,255,255,1);
  line-height:18px;
  margin-bottom: 18px;
  }
  .drTitle{
    font-size:14px;
    font-family:PingFangSC-Regular;
    font-weight:300;
    color:rgba(255,255,255,1);
    line-height:18px;
  }
  .drMore{
    display: block;
    font-size:14px;
    font-family:PingFangSC-Regular;
    font-weight:300;
    color:rgba(255,255,255,1);
    line-height:13px;
    text-decoration: underline;
    position: absolute;
    left: 15px;
    bottom: 16px;
    cursor:pointer;
  }
}
.drTeam img{
  width: 295px;
  height:295px;
}
.drTeam:hover{
  .drCntont{
     top:0;
  }
}
.drCntont{
  top:295px;
  left: 0;
  position: absolute;
  width: 295px;
  height:295px;
  text-align:left;
  background:rgba(0,0,0,0.5);
  color:rgba(255,255,255,1);
  transition: all .5s;
  padding: 15px;
}



.major{
  /*overflow: hidden;*/
  width: 100%;
  /*min-height: 326px;*/
  background-repeat: no-repeat;
  background-size:100% 100%;
  background-position:bottom;
  -moz-background-size: 100% 100%;
  padding-bottom: 50px;
}

.majorBtn{
  width:263px;
  height:38px;
  line-height: 38px;
  background:rgba(255,255,255,1);
  border-radius:20px;
  border:1px solid rgba(0,0,0,0.05);
  margin:50px auto 0;
}



.authenticationBox{
  max-width: 1140px;
  margin:60px auto 80px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.authenticationBox img{
  width: 520px;
  height:357px;
  display: block;
}
.authenticationBox ul{
  width: 520px;
  height:357px;
  display: block;
  text-align:left;
  padding: 20px 0 0 90px;
}
.authenticationBox ul li{
  display: block;
   font-size:20px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(20,20,20,1);
  line-height:46px;
  letter-spacing:1px;
  position: relative;
}
.authenticationBox ul li:before{
  width: 7px;
  height:7px;
  background-color:#141414;
  border-radius: 5px;
  content: " ";
  display: block;
  position: absolute;
  top:20px;
  left: -18px
}
.product{
  width: 100%;
  text-align:center;
  margin-bottom: 100px;
}
.indexproductBox{
  max-width: 1260px;
  width: 90vw;
  margin:60px auto;
  display: flex;
  flex-wrap:wrap;
  
}
.productMore{
  height:22px;
  font-size:14px;
  font-family:PingFangSC-Light;
  font-weight:300;
  color:rgba(120,120,120,1);
  line-height:20px;
  position: absolute;
  bottom:13px;
  left: 25px;
  text-decoration: underline;
  cursor:pointer;
}













.titleH2{
  font-size: 6vw;
  padding: 5vw;
  color: #141414;
  font-weight: bold;
  span{
    color: #B78975;
    margin:0 5px;
    border-bottom: 5px solid #F2EEEB;
  }
}
.description{
padding:5vw 10vw; 
font-size: 14px;
line-height: 6vw;
color: #505050;
}
.btnBox{
  height:26vw;
  display: flex;
  justify-content: center;
}
.bannerBox{
  width: 100vw;
  img{
    width: 100vw;
  }
}
.indexgoodsBox{
  width: 290px;
  margin:10px auto;
  background-color: #fff;
  min-height: 380px;
  border-radius: 4px;
  text-align: left;
  overflow: hidden;
  background:rgba(255,255,255,1);
  /*border:1px solid rgba(0,0,0,0.1);*/
  padding:0 25px;
  /*box-shadow:0px 0px 20px 0px rgba(202,196,191,0.31);*/
  box-shadow:0px 2px 5px 0px rgba(144,144,144,0.12), 0 3px 1px -2px transparent,0 5px 20px 0 rgba(202,196,191,0.31);
  border-radius:5px;
  position: relative;
  .indexgoodsName{
    margin:20px 0 5px;
    height:25px;
    font-size:20px;
    font-family:PingFangSC-Medium;
    font-weight:500;
    color:rgba(47,47,47,1);
    line-height:25px;
  }
  .indexgoodsTitle{

    height:40px;
    font-size:14px;
    font-family:PingFangSC-Light;
    font-weight:300;
    color:rgba(120,120,120,1);
    line-height:20px;
  }
  .indexgoodsBody{
    margin:5px 0 0;
    height:40px;
   font-size:14px;
    font-family:PingFangSC-Light;
    font-weight:300;
    color:rgba(20,20,20,1);
    line-height:20px;
    display: flex;
    img{
      width:25px;
      height:25px;
      display: inline-block;
      position: relative;
      top:-0.5px;
      margin-right: 10px;
    }
  }
  .goodsImg{
     width: 290px;
     height:180px;
     position: relative;
     left: -25px;
     cursor:pointer;
  }
}
.teamBox{
  width: 100vw;
  display: flex;
  overflow: auto; 
  transition: all 0.6s;
  margin-bottom: 14vw;
}


.itemBox{
  width: 64vw;
  height:127vw;
  text-align: left;
  padding-bottom: 5vw;
  margin-left: 8vw;
  background:rgba(255,255,255,1);
  border-radius:2vw;
  border: 0.2vw solid rgba(220,207,191,0.2);
  box-shadow:0px 0px 3px 0px rgba(220,207,191,0.55);
  margin-bottom: 1vw;
  img{
    width: 64vw;
    height:64vw;
    border-radius:2vw 2vw 0 0;
  }
  

}
.bottomBox{
    height:62vw;
    background-color: #C25E4D;
    padding-top: 15vw;
    color: #fff;
    font-size: 6vw;
    font-weight: bold;
  }
  .btnTop{
    width: 100vw;
    height:15vw;
    padding-top:5vw;
    display: flex;
    position: fixed;
    background-color: #fff;
    justify-content: center;
    top:5vw;
    left: 0;
    transition: all 0.6s;
  }
  .activeTop{
    top:-15vw;
  }

  .bottomBanner{
    width: 100%;
    height:42vw;
    max-height: 760px;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position:50% 38%;
    -moz-background-size: 100% 100%;
  }
  .bottomBtnBox{
    width: 100%;
    height:400px;
    background:rgba(194,94,77,1);
    overflow: hidden;
    .bottomBtnName{
      height:60px;
      font-size:30px;
      font-family:PingFangSC-Medium;
      font-weight:500;
      color:rgba(255,255,255,1);
      line-height:60px;
      letter-spacing:2px;
      margin:70px 0 30px;
      span{
        margin-left: 30px;
      }
    }
    .bottomBtnTitle{
      font-size:16px;
      font-family:PingFangSC-Light;
      font-weight:200;
      color:rgba(255,255,255,1);
      line-height:22px;
      letter-spacing:1px;
    }
    .whiteBtn{
      margin:46px auto;
      width: 350px;
      height:50px;
      border-radius: 50px;
      line-height: 50px;
      font-size:16px;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(20,20,20,1);

    }
  }

  .redBtn{
  width:135px;
  height:38px;
  background:rgba(194,94,77,1);
  border-radius:20px;
  font-size:16px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(255,255,255,1);
  display: block;
  text-align:center;
  line-height: 38px;
  margin-right: 15px;
}
.redBtn:hover{
  background:rgba(254,254,254,1);
  border:1px solid rgba(194,94,77,1);
  color:rgba(194,94,77,1);
  text-decoration:none;
}
.whiteBtn{
  width:135px;
  height:38px;
  background:rgba(254,254,254,1);
  border-radius:20px;
  border:1px solid rgba(230,230,230,1);
  display: block;
  text-align:center;
  line-height: 38px;
  font-size:16px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(194,94,77,1);
  line-height:38px;
  text-decoration:none;
}
.whiteBtn:hover{
   background:rgba(254,254,254,1);
  border:1px solid rgba(194,94,77,1);
  color:rgba(194,94,77,1);
  text-decoration:none;
}
@media only screen and (max-width: 1000px) {
 .topindexTitle{
  font-size: 24px;
  line-height: 40px;
 }
 .topindexDescription{
  font-size: 14px;
  line-height: 20px;
 }
}



.inform{
  width: 100%;
  height: 100%;
  background-color: rgba(14, 14, 14, 0.6);
  position: fixed;
  top:0;
  left: 0;
  z-index: 999;
}
.informBox{
 /* width: 60%;
  height: 80%;*/
  background-color: #fff;
  /*position: absolute;
  top:10%;
  left: 20%;*/
  letter-spacing:2px;
}
.informTitle{
  height: 90px;
  text-align: center;
  line-height: 100px;
  color: rgba(194,94,77,1);
  font-weight: 600;
}
.informTxt{
  text-align: left;
  /*font-size: 20px;*/
  padding: 10px 40px;
  text-indent: 2em;
}
.informBtnBox{
  /*position: absolute;
  left: 0;*/
  width: 100%;
  margin-bottom:60px;
}
.informBtn{
    margin:0 auto;
    color: #fff;
    background-color: rgba(194,94,77,1);
    border-radius: 100px;
    width: 300px;
    line-height: 60px;
    font-size: 22px;
    font-weight: 500;
    text-align: center;
    text-indent: 0;
    letter-spacing: 1px;
}
</style>
